import type { Tag, TagType } from '~/api/interface';
import type { ApplicationSceneTag } from '~/api/module/scenarios';

export const useCenterTags = () => {
  return useState<TagType>('centerTags', () => ({ tag_header: [], tags: [] }));
};

export const useCharacterTags = () =>
  useState<TagType>('digitalTags', () => ({ tag_header: [], tags: [] }));

export type TagInfo = Tag & { ids: string };

export const useTagMap = () => {
  return useState<Record<string, TagInfo>>('tagMap', () => ({}));
};

export const useScenariosTags = () => useState<ApplicationSceneTag[]>('scenariosTags', () => []);
